import React, { useState, useEffect } from 'react'
import API from '../../utils/API'
import './Password.css'
import { FormattedMessage } from 'react-intl';

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passcode, setPasscode] = useState('');
  const [email, setEmail] = useState('');
  const [minimumLength, setMinimumLength] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [verifyExpired, setverifyExpired] = useState(false);
  const [resendSuccess, setresendSuccess] = useState('');
  const [resendBtnEnable, setresendBtnEnable] = useState(false)

  // Global Policy IDs
  const policyID = {
    password: 'd53bcda0-a108-4b18-b066-1b04bdfbe200',
    twoFactorAuth: '8eef3696-e258-40e7-a611-bafa2bb42c71',
  }

  useEffect(() => {
    checkUrl();
  }, [])

  // Get passcode and email from the URL generated by reset email link.
  function checkUrl() {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    if(params.get("passcode") && params.get("email")) {
      setPasscode(params.get("passcode"));
      const parsedEmail = params.get("email").replace(' ', '+')
      setEmail(parsedEmail);
    }
  }

  function handleSubmit() {
    // switch(newPassword) {
    //   case(confirmPassword):
    //     API.resetPassword({
    //       email, 
    //       passcode, 
    //       password: newPassword
    //     })
    //     break;
    //   case(''):
    //     setError('Missing input in password field.')
    //     break;
    //   default:
    //     setError("Passwords do not match.")
    //     break;
    // }
    if(newPassword && confirmPassword) {
      if(newPassword !== confirmPassword) {
        setError("PASSWORD_NOT_MATCH")
        return; 
      }

      API.verifyUser(email.trim(), newPassword.trim(), passcode.trim()
      ).then((res)=>{
        setSuccess(true);
      }).catch(err => {
        if(err.response && err.response.data && err.response.data == "PASSCODE_EXPIRED_OR_INVALID" ){
          setverifyExpired(true);
          setError(<FormattedMessage id="VERIFICATION_EMAIL_LINK_EXPIRED" values={{email: <b>{email}</b>}}/>);
        }
        else if(err.response && err.response.status === 400){
          setError(<FormattedMessage id={err.response.data}/>)
        }else{
          setError(<FormattedMessage id="SERVER_ERROR"/>)
        }
        setresendBtnEnable(true);
      })

    } else {
      setError(<FormattedMessage id="FIELD_CANNOT_EMPTY"/>);
      return;
    }
  }

  const handleResend = () => {  
    setresendBtnEnable(false);  
    API.resendUserVerification(email)
      .then(res => {
        setError('');
        setresendSuccess(<FormattedMessage id="RESEND_VERIFICATION_EMAIL_SENT"/>);
        setresendBtnEnable(true);
    }).catch(err => {
        console.error(err)   
        let errMsg = '';         
        if(err.response && err.response.status === 400){
            errMsg = err.response.data;
          }else{
            errMsg = <FormattedMessage id="SERVER_ERROR"/>;
        }
        setError(errMsg);
        setresendBtnEnable(true);
    })
  }

  const handleDone = (event) => {
    event.preventDefault()
    window.location = '/login'
  }

  const logoutAndGoToLogin = (e) => {
    e.preventDefault();
    API.logout()
      .then(res => {
      }).catch(err => {
      }).finally(()=>{
        localStorage.removeItem('token');
        window.location = '/login'
      })
  }

  return (
    <div className='password container py-5 h-100'>
      <div className='row d-flex justify-content-center p-3'>
        <div className='col-xl-4'>
          <form className="needs-validation">
            <div className='header text-center mb-4'>
              <h2><FormattedMessage id="ACTIVATE"/></h2>
            </div>
              {success ? 
                <div className='card'>
                  <div className='form-outline mb-3 text-center'>
                    <p><FormattedMessage id="ACTIVATE_USER_SUCCESS"/></p>
                  </div>
                  <div className='login-btn row text-center'>
                    <a onClick={logoutAndGoToLogin} href='../login'><FormattedMessage id="LOG_IN" /></a>
                  </div>
                </div>
                : 
                !verifyExpired &&
                <div className='card'>
                  <div className='form-outline mb-3'>
                    <label className='form-label' htmlFor='newPassword'><FormattedMessage id="NEW_PASSWORD" /></label>
                    <input onChange={(e) => setNewPassword(e.target.value)} value={newPassword} name='newPassword' type='password' className='form-control rounded-1' required/>
                    {minimumLength ? 
                      <div>
                        <ul>
                          <li className={`passReq ${(newPassword === confirmPassword && newPassword.length > 0) ? "text-success" : "text-danger"}`}>
                            <FormattedMessage id="PASSWORD_NOT_MATCH" />
                          </li>
                        </ul>
                      </div>
                      :
                      null
                    }
                  </div>
                  <div className='form-outline mb-4'>
                    <label className='form-label' htmlFor='confirmPassword'><FormattedMessage id="CONFIRM_PASSWORD" /></label>
                    <input onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} name='confirmPassword' type='password' className='form-control rounded-1' />
                  </div>
                {error ? <div className='error'>{error}</div> : null}
                <button type='button' className='btn btn-primary btn-block mb-1' onClick={handleSubmit}><FormattedMessage id="SUBMIT" /></button>
                {/* <div className='login-btn row text-center'>
                  <a href='../login'><FormattedMessage id="LOG_IN" /></a>
                </div> */}
                </div>
              }
              {verifyExpired && error &&
                <div className='card'>
                  <div className='form-outline mb-4'>
                    {/*error ? <div className='error'>{error}</div> : null*/}
                    <label className='error'>{error}</label>
                  </div>
                  <button type='button' className='btn btn-primary btn-block mb-1' onClick={handleResend} disabled={!resendBtnEnable}><FormattedMessage id="RESEND" /></button>
                </div>
              }
              {resendSuccess &&
                <div className='card'>
                  <div className='form-outline text-center mb-4'>
                    <label className='form-lable'>{resendSuccess}</label>
                  </div>
                  <button type='button' className='btn btn-primary btn-block' onClick={handleDone}><FormattedMessage id="DONE_BTN" /></button> 
                </div>
              }
          </form>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword